import { Stack } from '@cast/design-system';
import type { StackProps } from '@cast/design-system';

export const InputPairContainer = (props: StackProps) => (
  <Stack
    display="grid"
    gridTemplateColumns="1fr 1fr"
    columnGap={8}
    rowGap={24}
    alignItems="flex-end"
    {...props}
  />
);
